import ol from '../ol';
var planningCSV = '';

function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';
  var i;
  var row1 = true;
  var headerlist = [];
  for (i = 0; i < array.length; i++) {
    for (var index in array[i]) {
      if (headerlist.indexOf(index) == -1) headerlist.push(index);
    }
  }
  for (i = 0; i < array.length; i++) {
    var line = '';
    var preline = '';
    headerlist.forEach(function (index) {
      if (line != '') line += ',';
      if (preline != '') preline += ',';
      preline += '"' + index + '"';
      line +=
        '"' +
        String(array[i][index])
          .replace(/"/g, '')
          .replace('null', '')
          .replace('undefined', '')
          .replace('[object Object]', '') +
        '"';
    });
    if (row1) str += preline + '\r\n';
    str += line.replace(/\n/g, ',') + '\r\n';
    row1 = false;
  }

  return str;
}

export function downloadTitles(titleList, state) {
  if (!state) state = window.state;
  if (!titleList) titleList = state.clickedFeatures;
  var head = 'Title Number:, Class:, Status:, Insert Date:, Update Date:\r\n';
  var body = '';
  titleList.forEach(function (f) {
    var a = f.attributes;
    body += `${a.title_no},${a.class_of_title},${a.registered_status},${a.insert_date},${a.update_date}\r\n`;
  });
  var csv = head + body;
  var filename = 'title_numbers.csv';
  if (!csv.match(/^data:text\/csv/i) && !navigator.msSaveOrOpenBlob && !navigator.msSaveBlob) {
    csv = 'data:text/csv;charset=utf-8,' + csv;
  }
  var data = encodeURI(csv);
  var blob;
  if (navigator.msSaveOrOpenBlob) {
    blob = new Blob([decodeURIComponent(data)]);
    navigator.msSaveOrOpenBlob(blob, filename);
    return;
  } else if (window.navigator.msSaveBlob) {
    // for IE browser
    blob = new Blob([decodeURIComponent(data)]);
    window.navigator.msSaveBlob(blob, filename);
    return;
  }
  var link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export function downloadCSV(args, state) {
  var data, filename, link;
  var suffix = project.casefile_ref !== '' ? project.casefile_ref : project.project_id;
  filename = args.filename || 'Planning_Applications_' + suffix + '.csv';
  planningCSV = convertToCSV(JSON.stringify(state.csvArray));
  var csv = planningCSV;
  data = encodeURIComponent(csv);
  if (!csv.match(/^data:text\/csv/i) && !navigator.msSaveOrOpenBlob && !navigator.msSaveBlob) {
    data = 'data:text/csv;charset=utf-8,' + data;
  }
  var blob;
  if (navigator.msSaveOrOpenBlob) {
    blob = new Blob([decodeURIComponent(data)]);
    navigator.msSaveOrOpenBlob(blob, filename);
    return;
  } else if (window.navigator.msSaveBlob) {
    // for IE browser
    blob = new Blob([decodeURIComponent(data)]);
    window.navigator.msSaveBlob(blob, filename);
    return;
  }
  link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export function downloadJSON(layer, layer2) {
  let json = ol.functions.getFeaturesJSON(false, layer, layer2, true);
  json = JSON.parse(json);
  json.crs = {
    type: 'name',
    properties: { name: 'urn:ogc:def:crs:EPSG::27700' },
  };
  json = JSON.stringify(json, null, 2);
  json = 'data:application/json;charset=utf-8,' + json.replace(/#/g, '');
  let data = encodeURI(json);
  let link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', 'acumen-export.json');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export function downloadFile(url, filename) {
  if (navigator.msSaveBlob || navigator.msSaveOrOpenBlob) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      if (this.status == 200) {
        var blob = this.response;
        if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename);
        else navigator.msSaveBlob(blob, filename);
      }
    };

    xhr.onerror = function (e) {
      window.alert('Error ' + e.target.status + ' occurred while receiving the document.');
    };
    xhr.send();
  } else {
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
  }
}

function downloadSample(baseURL, file_url) {
  if (navigator.msSaveBlob || navigator.msSaveOrOpenBlob) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', file_url, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      if (this.status == 200) {
        var blob = this.response;
        if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, file_url);
        else navigator.msSaveBlob(blob, file_url);
      }
    };

    xhr.onerror = function (e) {
      window.alert('Error ' + e.target.status + ' occurred while receiving the document.');
    };
    xhr.send();
  }
  var link = document.createElement('a');
  link.href = baseURL + file_url;
  link.download = file_url;
  link.click();
}
export function downloadSamples(settings) {
  downloadSample(
    settings.baseURL + '/samples/',
    'SNaPS-Land & Buildings at, 17-21, The Borough, Canterbury, CT1 2DR.pdf',
    'pdf',
  );
  setTimeout(function () {
    downloadSample(
      settings.baseURL + '/samples/',
      'SNaPS-Land & Buildings at, 17-21, The Borough, Canterbury, CT1 2DR.csv',
      'csv',
    );
  }, 2000);
}
